
// const BACK_END_URL = "https://school-management-system-lia.herokuapp.com"
export const BACK_END_URL = "https://school-management-system-lia.herokuapp.com"
